import React, { useState , useMemo} from "react";
import { MDBIcon } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";

function CFNodes(props) {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const hasAttendantNode = useMemo(() => {
    return props.nodes && props.nodes.some(node => node.type === "attendantNode");
  }, [props.nodes]);

  const onDragStart = (event, nodeType) => {
    if ((nodeType === "directoryNode" || nodeType === "operatorNode") && !hasAttendantNode) {
      event.preventDefault();
      return;
    }
    props.onDragStart(event, nodeType);
  };

  const onClick = (event, nodeType) => {
    if ((nodeType === "directoryNode" || nodeType === "operatorNode") && !hasAttendantNode) {
      event.preventDefault();
      return;
    }
    //props.onClick(event, nodeType, props.nodes);
  };

  return (
    <>
      <div className="node_Container_main">
        <div className="node_Container">
          <div
            className="nodes nodesGreen"
            onDragStart={(event) => onDragStart(event, "callerIdNode")}
            onClick={(event) => onClick(event, "callerIdNode")}
            draggable
          >
            Route by CallerID
          </div>
          <div
            className="nodes nodeprimary"
            onDragStart={(event) => onDragStart(event, "huntNode")}
            onClick={(event) => onClick(event, "huntNode")}
            draggable
          >
            Hunt Group
          </div>
          <div
            className="nodes nodeprimary"
            onDragStart={(event) => onDragStart(event, "attendantNode")}
            onClick={(event) => onClick(event, "attendantNode")}
            draggable
          >
            Auto Attendent
          </div>
          {/* Call Queue */}
          {/* <div
            className="nodes nodepurple"
            onDragStart={(event) => onDragStart(event, "ACDNode")}
            onClick={(event) => onClick(event, "ACDNode")}
            draggable
          >
            Call Queue
          </div> */}

          <div
            className="nodes nodepurple"
            onDragStart={(event) => onDragStart(event, "externalNumberNode")}
            onClick={(event) => onClick(event, "externalNumberNode")}
            draggable
          >
            External Numbers
          </div>

          {/* Luna node added  */}
          
          {/* Hideing luna node */}
          {/* <div
            className="nodes nodeluna"
            onDragStart={(event) => onDragStart(event, "lunaNode")}
            onClick={(event) => onClick(event, "lunaNode")}
            draggable
          >
            Luna
          </div> */}
          
          <div
            className="nodes nodeyellow"
            onDragStart={(event) => onDragStart(event, "voicemailNode")}
            onClick={(event) => onClick(event, "voicemailNode")}
            draggable
          >
            Voicemail
          </div>
          <div
            className="nodes nodedarkYellow"
            onDragStart={(event) => onDragStart(event, "announcementNode")}
            onClick={(event) => onClick(event, "announcementNode")}
            draggable
          >
            Announcement
          </div>
          <div
            className="nodes nodeuser_ext"
            onDragStart={(event) => onDragStart(event, "userExtensionNode")}
            onClick={(event) => onClick(event, "userExtensionNode")}
            draggable
          >
            Users & Extensions
          </div>

          {/* New nodes  */}
          {/* Conditional nodes - enabled only when attendantNode exists */}
          <div className={!hasAttendantNode ?"cursor-notAllowed hasAttendantNodeTooltip w-100":"w-100"}>
          <div
            className={`nodes nodedirectory ${!hasAttendantNode ? 'node-disabled' : ''}`}
            onDragStart={(event) => onDragStart(event, "directoryNode")}
            onClick={(event) => onClick(event, "directoryNode")}
            draggable={hasAttendantNode}
            style={{
              opacity: hasAttendantNode ? 1 : 0.3, 
              pointerEvents: hasAttendantNode ? 'auto' : 'none'
            }}
           
            >
            Directory
          </div>
          </div>

          {/* <div
            className={`nodes nodeoperator ${!hasAttendantNode ? 'node-disabled' : ''}`}
            onDragStart={(event) => onDragStart(event, "operatorNode")}
            onClick={(event) => onClick(event, "operatorNode")}
            draggable={hasAttendantNode}
            style={{
              opacity: hasAttendantNode ? 1 : 0.5,
              cursor: hasAttendantNode ? 'grab' : 'not-allowed',
              pointerEvents: hasAttendantNode ? 'auto' : 'none'
            }}
            title={!hasAttendantNode ? 'Add Auto Attendant node first' : ''}
          >
            Operator
          </div> */}

          <div
            className="nodes nodered"
            onDragStart={(event) => onDragStart(event, "endCallNode")}
            onClick={(event) => onClick(event, "endCallNode")}
            draggable
          >
            End Call
          </div>
        </div>
        <div>
          <div
            className="nodes AddNote"
            onDragStart={(event) => onDragStart(event, "notes")}
            onClick={(event) => onClick(event, "notes")}
            draggable
          >
            {/* <MDBIcon fas icon="plus" className="me-2" /> */}
            Add Note
          </div>
        </div>
      </div>
      {!hasAttendantNode &&
        <Tooltip anchorSelect=".hasAttendantNodeTooltip" place="right" className="exampleTooltip">
          Please add an Auto Attendant node before adding a Directory node.
        </Tooltip>
      }
    </>
  );
}

export default CFNodes;
